<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="售后联系人" name="after_sale_name"></c-form-item>
					<c-form-item type="input" label="售后联系方式" name="after_sale_mobile"></c-form-item>
					<c-form-item type="input" label="售后地址" name="after_sale_address"></c-form-item>
					<c-form-item type="checkbox" label="状态" name="state" :options="state"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" power="b_after_sale_address_edit"  @click="add">新增售后地址</c-button>
			</m-operate>
			
			<c-table ref="table" code="">
				<c-table-column
					label="售后人"
					name="after_sale_name"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="60"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 1" style="color:red">{{stateName[data.state]}}</span>
						<span v-if="data.state == 2" style="color:green">{{stateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="售后人联系方式"
					name="after_sale_mobile"
					width="130"
				></c-table-column>
				
				<c-table-column
					label="售后地址"
					name="after_sale_address"
					width="300"
				></c-table-column>

<!--				<c-table-column
					label="所属商家"
					name="stationed_name"
					width="160"
				></c-table-column>-->

				<c-table-column
					label="创建时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button power="b_after_sale_address_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_after_sale_address_edit" @click="del(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="uEdit" :title="editState ? '编辑售后地址' : '新增售后地址'" width="600" @resolve="submit">
			<c-form ref="uForm">
				<c-form-item type="input" label="售后联系人" name="after_sale_name" required></c-form-item>
				<c-form-item type="input" label="售后联系方式" name="after_sale_mobile" required></c-form-item>
                <c-form-item type="region" label="售后地址省市县"
                             province-name="province_id"
                             city-name="city_id"
                             county-name="county_id"
                             required></c-form-item>
                <c-form-item type="input" label="售后详细地址" name="after_sale_address" required></c-form-item>
				<c-form-item type="radio" label="是否启用" name="state" :options="state" required></c-form-item>
				<c-form-item type="hidden" name="id"></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_task_center_list',
		
		data() {
			return {
				stateName: {
					1: '禁用',
					2: '启用'
				},
				state: [{
						name: '禁用',
						value: "1"
					},{
						name: '启用',
						value: "2"
					}
				],
				editState: false
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/after_sale_address/list',
					data
				});
			},
			add(stop) {
				this.editState = false;
				this.$refs.uForm.clear();
				this.$refs.uEdit.open();
			},
			edit(val) {
				this.editState = true;
				this.$refs.uForm.set(val);
				this.$refs.uEdit.open();
			},
			del(val) {
				this.$confirm({
					text: '确定要删除【'+val.after_sale_address+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/after_sale_address/remove',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			submit(stop) {
				stop();
				let submitUrl = '/after_sale_address/add';
				if(this.editState){
					submitUrl = '/after_sale_address/edit';
				}
				this.$refs.uForm.submit({
					url: submitUrl,
					rule: {
						after_sale_name: [{
							type: 'empty',
							word: '请填写售后联系人'
						}],

						after_sale_mobile: [{
							type: 'empty',
							word: '请填写售后联系方式'
						}],

						after_sale_address: [{
							type: 'empty',
							word: '请填写售后地址'
						}],

						state: [{
							type: 'empty',
							word: '请选择是否启用'
						}]
					},
					dataFormatter: data => {
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '操作成功',
							icon: 'success'
						});
						this.$refs.table.update();
						this.$refs.uEdit.close();
					},
				});
			}
		}
	}
</script>